import styled from 'styled-components';

export const SaveGamesWidgetBox = styled.div`
    background-color: ${props => props.theme.colors.background};
    margin-top: 1rem;
    padding: 0;
    width: 100%;
    line-height: 3.75rem;

    align-items: center;

    display: flex;
    flex-direction: column;
  
    border-radius: 5px;
    max-width: 100%;

`;
